import { apiDelete, apiGet, apiPost, apiPut } from './api-service';
import { getUserDetails } from './session-service';

export async function getForm(id?: string) {
    try {
        const response = await apiGet('core', `form/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}

export async function addForm(newDetails: any) {
    const response = await apiPost('core', `form`, newDetails);
    return response?.content;
}

export async function submitForm(newDetails: any) {
    const response = await apiPost('core', `form_result`, newDetails);
    return response?.content;
}

export async function updateForm(newDetails: any, id?: string) {
    if (!id) {
        id = getUserDetails().client_id;
    }
    const response = await apiPut('core', `form/${id}`, newDetails);

    return response?.content;
}

export async function removeForm(id: any) {
    return await apiDelete('core', `form/${id}`);
}

export async function getDSFPDF() {
    try {
        const response = await apiGet('dsf', ``);
        return response.content;
    } catch (e) {
        return {};
    }
}


export async function updatePoliciesProcedure(id: string, newDetails: any) {
    const response = await apiPut('core', `site-policies-procedures/${id}`, newDetails);

    return response?.content;
}
